import { api } from './client';

export const transportadorasApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/transportadoras${qs ? `?${qs}` : ''}`);
  },
  obter: (id) => api.get(`/transportadoras/${id}`),
  criar: (dados) => api.post('/transportadoras', dados),
  atualizar: (id, dados) => api.put(`/transportadoras/${id}`, dados),
  remover: (id) => api.del(`/transportadoras/${id}`),
  obterContatos: (id) => api.get(`/transportadoras/${id}/contatos`),
  salvarContatos: (id, itens) => api.put(`/transportadoras/${id}/contatos`, { itens })
};
